import React, { useState, useEffect } from "react";
import ProviderCbxFilter from "../utilities/ProviderCbxFilter";

const TracksByProfileTable = ({
  gameProviders,
  setSelectedProvider,
  selectedProvider,
  trackList,
  tracksByProfile,
  tracksByProfileChangeHandler,
  uiTypeSelected,
  setUiTypeSelected,
  profileOptionSelected,
  setTracksByProfile,
  setHasChanges,
  selectAll,
  setSelectAll,
  getTracksListCbx,
  selectedRow,
}) => {
  const [tracksByProfilesFilter, setTracksByProfilesFilter] = useState([]);

  let headers,
    tableTracksByProfile = [];

  headers = (
    <tr className="text-center" style={{ cursor: "default" }}>
      <th hidden>TrackID</th>
      <th style={{ width: "160px" }}>Provider</th>
      <th style={{ width: "130px" }}>Track Code</th>
      <th>Track Name</th>
    </tr>
  );

  useEffect(() => {
    let filteredTracksByProfile;
    filteredTracksByProfile = tracksByProfile.filter(
      (item) => item.UIType === parseInt(uiTypeSelected),
    );
    setTracksByProfilesFilter(filteredTracksByProfile);
  }, [tracksByProfile]);

  // This useEffect filters the table by Provider
  useEffect(() => {
    getTracksListCbx(selectedProvider);
  }, [selectedProvider]);

  useEffect(() => {
    let filteredTracksByProfile;

    if (uiTypeSelected === 0) {
      filteredTracksByProfile = tracksByProfile.filter(
        (item) => item.UIType === parseInt(uiTypeSelected),
      );
    } else {
      filteredTracksByProfile = tracksByProfile;
    }

    // Provider combo box filter
    if (uiTypeSelected) {
      filteredTracksByProfile = filteredTracksByProfile.filter(
        (item) => item.UIType === parseInt(uiTypeSelected),
      );
    }

    setTracksByProfilesFilter(filteredTracksByProfile);
  }, [uiTypeSelected, profileOptionSelected, tracksByProfile]);

  // This useEffect filters the table by UI Type
  const uiTypeChangeHandler = (e) => {
    setUiTypeSelected(e.target.value);
  };

  if (trackList) {
    trackList.length !== 0
      ? (tableTracksByProfile = trackList.map((item, i) => {
          if (tracksByProfile) {
            var className = tracksByProfilesFilter.some(
              (profiles) => profiles.TrackID === item.TrackID,
            )
              ? "classActiveMultiselect"
              : "";
          }

          return (
            <tr
              key={i}
              className={`${className} ${
                selectedRow === null ? "row-disabled" : ""
              }`}
              onClick={() => tracksByProfileChangeHandler(item.TrackID, i)}
              style={{ cursor: "pointer" }}
            >
              <td className="d-none">{item.TrackID}</td>
              {/* Provider Name */}
              <td
                style={{
                  verticalAlign: "middle",
                  textAlign: "center",
                  width: "160px",
                  whiteSpace: "normal",
                }}
              >
                {item.ProviderName}
              </td>
              {/* Track Code */}
              <td
                style={{
                  verticalAlign: "middle",
                  textAlign: "center",
                  width: "130px",
                }}
              >
                {item.TrackCode}
              </td>
              {/* Track Name */}
              <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                {item.TrackName}
              </td>
            </tr>
          );
        }))
      : (tableTracksByProfile = (
          <tr>
            <td colSpan={4} style={{ textAlign: "center" }}>
              No Tracks to display
            </td>
          </tr>
        ));
  }

  const handleSelectAll = () => {
    if (!selectAll) {
      const tracks = trackList.map((item) => ({
        TrackID: item.TrackID,
        UIType: parseInt(uiTypeSelected),
      }));
      const filteredTracks = tracksByProfile.filter(
        (item) => item.UIType !== parseInt(uiTypeSelected),
      );
      const updatedTracks = [...filteredTracks, ...tracks];
      setTracksByProfile(updatedTracks);
    } else {
      const filteredTracks = tracksByProfile.filter(
        (item) => item.UIType !== parseInt(uiTypeSelected),
      );
      setTracksByProfile(filteredTracks);
    }
    setSelectAll(!selectAll);
    setHasChanges(true);
  };

  return (
    <div>
      <div style={{ textAlign: "center" }}>
        <p
          className="lead"
          style={{ color: "#8c8c8c", fontSize: "16px", cursor: "default" }}
        >
          Specify which tracks should be available for wagering for each Profile
          in each wagering interface.
        </p>
      </div>
      <div className="row">
        <div className="col-md-6">
          {gameProviders && (
            <ProviderCbxFilter
              gameProviders={gameProviders}
              setSelectedProvider={setSelectedProvider}
              selectedProvider={selectedProvider}
              widthCbx={"100%"}
              label={true}
              disabled={selectedRow === null}
            />
          )}
        </div>
        <div className="col-md-6">
          <label
            className="lead"
            style={{
              fontSize: "18px",
              justifyContent: "normal",
            }}
          >
            UI Type :
          </label>
          <select
            id="TrackID"
            name="TrackID"
            className="form-control"
            style={{ fontSize: "14px", cursor: "pointer" }}
            value={uiTypeSelected}
            onChange={uiTypeChangeHandler}
            disabled={selectedRow === null}
          >
            <option value={0}>Call Center</option>
            <option value={1}>Internet</option>
            <option value={2}>EPOS</option>
          </select>
        </div>
      </div>
      <div className="form-check mt-2">
        <input
          type="checkbox"
          className="form-check-input"
          id="exampleCheck1"
          checked={selectAll}
          onChange={handleSelectAll}
          disabled={selectedRow === null}
          style={{ cursor: "pointer" }}
        />
        <label
          className="form-check-label"
          htmlFor="exampleCheck1"
          style={{ color: "#8c8c8c", fontSize: "16px" }}
        >
          Select All
        </label>
      </div>
      {trackList && (
        <div
          className="mt-2 tableTracks"
          style={{
            overflow: "auto",
            marginTop: "10px",
            boxShadow: "-10px 5px 10px #d9e6f2",
          }}
        >
          <table className="table table-hover table-sm">
            <thead
              style={{ position: "sticky", top: "0", background: "#d9d9d9" }}
            >
              {headers}
            </thead>
            <tbody className="table-lg">{tableTracksByProfile}</tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default TracksByProfileTable;
